<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 客渠管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>收货地址信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.fullName" placeholder="公司全称" class="handle-input mr10"></el-input>
				<el-select v-model="query.acquiesce" placeholder="请选择是否是默认开票信息">
					<el-option key="" label="请选择是否时默认开票信息"></el-option>
					<el-option :key="true" label="是" :value="true"></el-option>
					<el-option :key="false" label="否" :value="true"></el-option>
				</el-select>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="fullName" label="公司全称" width="240"></el-table-column>
				<el-table-column prop="bankName" label="开户行"></el-table-column>
				<el-table-column prop="cardNo" label="对公账号"></el-table-column>
                <el-table-column prop="acquiesce" label="是否默认" :formatter="isAcquiesceFormat" width="80"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
                <el-table-column label="操作" width="250" align="center">
                    <template slot-scope="scope">
						 <el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-star-on"
                            @click="handleSetDefault(scope.$index, scope.row)" 
							v-if = "controll['default'] && !scope.row.acquiesce"
                        >置为默认</el-button>
						<el-button
                            type="text"
                            icon="el-icon-star-off"
                            @click="handleCancelDefault(scope.$index, scope.row)"
							v-if = "controll['default'] && scope.row.acquiesce"
                        >取消默认</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="详情" :visible.sync="showVisible" width="40%">
            <el-form ref="show" :model="show" label-width="80px" :rules="rules">
				<el-form-item label="公司全称: ">
					{{show.fullName}}
				</el-form-item>
				<el-form-item label="税务号: ">
					{{show.taxNo}}
				</el-form-item>
				<el-form-item label="联系电话: ">
					{{show.tel}}
				</el-form-item>
				<el-form-item label="注册地址: ">
					{{show.address}}
				</el-form-item>
				<el-form-item label="开户行: ">
					{{show.bankName}}
				</el-form-item>
				<el-form-item label="对公账号: ">
					{{show.cardNo}}
				</el-form-item>
				<el-form-item label="备注: ">
					{{show.remark}}
				</el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchInvoiceData, saveInvoice, deleteInvoice, getInvoice, setDefault, cancelDefault } from '../../../api/index';
export default {
    name: 'express-address',
    data() {
        return {
            query: {
                fullName: '',
                acquiesce: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            showVisible: false,
            pageTotal: 0,
            show: {},
            idx: -1,
            id: -1,
			controll:{}
        };
    },
    created() {
		this.controll = getControll("express-address");
        this.getData();
    },
    methods: {	
		isAcquiesceFormat(row, column, cellValue) {
			return cellValue?"是":"否";
		},
        getData() {
            fetchInvoiceData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteInvoice([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleShow(index, row) {
			getInvoice(row.id).then(res => { 
				if (res.code == 0 ) {
					this.show = res.data;
					this.showVisible = true;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
		},
		handleSetDefault(index, row) {
			setDefault(row.id).then(res => { 
				if (res.code == 0 ) {
					this.$message.success('设置成功');
					this.getData();
				} else {
					this.$message.error("设置失败！" + res.message);
				}
            });
		},
		handleCancelDefault(index, row) {
			cancelDefault(row.id).then(res => { 
				if (res.code == 0 ) {
					this.$message.success('取消成功');
					this.getData();
				} else {
					this.$message.error("取消失败！" + res.message);
				}
            });
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
